import { render, staticRenderFns } from "./verification-record.vue?vue&type=template&id=e8fb2eaa&scoped=true"
import script from "./verification-record.vue?vue&type=script&lang=js"
export * from "./verification-record.vue?vue&type=script&lang=js"
import style0 from "./verification-record.vue?vue&type=style&index=0&id=e8fb2eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fb2eaa",
  null
  
)

export default component.exports